export interface LtcTiming {
  policyIssueAge: number | undefined;
  careStartAge: number | undefined;
  yearsUntilLtc: number;
}

export function getLtcTiming(
  clientAge: number | undefined,
  predictedCareStartAge: number | undefined,
): LtcTiming {
  if (typeof clientAge !== 'number' || !Number.isFinite(clientAge)) {
    return { policyIssueAge: undefined, careStartAge: undefined, yearsUntilLtc: 0 };
  }

  if (typeof predictedCareStartAge !== 'number' || !Number.isFinite(predictedCareStartAge)) {
    return { policyIssueAge: clientAge, careStartAge: undefined, yearsUntilLtc: 0 };
  }

  const careStartAge = Math.max(Math.round(predictedCareStartAge), clientAge);

  return {
    policyIssueAge: clientAge,
    careStartAge,
    yearsUntilLtc: careStartAge - clientAge,
  };
}
